import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IBadInventoryProductFilterBody,
  IBadInventoryProductFilterResponse,
  IBadInventoryProductFilterResponseData,
  IBadInventoryProductFilterResponseDataResponse,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setRotaerrorIds } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useBadInventoryFilterAPI = () => {
  const configuration = useConfiguration();
  const [data, setData] = useState<any>();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (filterBody: IBadInventoryProductFilterBody, page_number, page_size) => {
      try {
        dispatch(
          setLoading({
            key: "isCustomerBookingsFetchInProgress",
            status: true,
          }),
        );

        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(
            `${INVENTORY_MODULE?.BAD_INVENTORY_DATA?.baseURL}?page_size=${page_size}&page_number=${page_number}`,
            filterBody,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IBadInventoryProductFilterResponse>) => {
            if (res.data.status === true) {
              setData(res.data.data);
              dispatch(
                setLoading({
                  key: "isCustomerBookingsFetchInProgress",
                  status: false,
                }),
              );
              return { status: true, message: "batch" };
            } else {
              setData([]);
              dispatch(
                setLoading({
                  key: "isCustomerBookingsFetchInProgress",
                  status: false,
                }),
              );
              return { status: false, message: "product_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            setData([]);
            return { status: false, message: "product_not_filtered" };
          });
        return response;
      } catch (e: any) {
        setData([]);
        dispatch(
          setLoading({
            key: "isCustomerBookingsFetchInProgress",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { data, execute };
};
